<div class="page">
       <kgrid *ngIf="filterInfo && filterInfo.length>0"
              [apiName]="apiName"
              [label]="label"
              [areaName]="areaName"
              [name]="apiName"
              [defaultFilterKey]="filterInfo"
              reportName="LocalSetting"
              pathPreFix="SALE"
              [inputEditorform]="inputEditorform"
              [isAdd]="isAdd"
              [isEdit]="isEdit"
              [isDelete]="isDelete">
       </kgrid>       
</div>